export enum SORT_TYPES {
  LAST_STATE_MODIFICATION = 'LastStateModification',
  REQUEST_LINE_LAST_MODIFICATION_TIME_UTC = 'RequestLineLastModificationTimeUtc',
  STOCK_INPUT_TIME_UTC = 'StockInputTimeUtc',
}
